import React from 'react';
import { Popconfirm, Table, Button, Tooltip } from 'antd';
import { Trash2, User, Mail, UserCheck } from 'lucide-react';
import { SectionCard, StatusTag, EmptyState, IconActions } from '../../common';
import AuditorsTableActions from './AuditorsTableActions';

function AuditorsTable({ navigateAuditor, auditors, rows, loading, removeAuditor, setRows, exporting, onExport }) {
    const AuditorColumns = [
        {
            title: 'Auditor',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <div className="flex items-center gap-3 py-0.5">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-surface-100 text-surface-500 text-[15px]">
                        <User />
                    </span>
                    <div className="min-w-0">
                        <button
                            type="button"
                            onClick={() => navigateAuditor(record._id)}
                            className="block text-left text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors">
                            {text}
                        </button>
                        <span className="text-xs text-surface-400">{record.rif || 'Sin RIF'}</span>
                    </div>
                </div>
            ),
            sorter: (a, b) => (a.name || '').localeCompare(b.name || '')
        },
        {
            title: 'Correo',
            dataIndex: 'email',
            key: 'email',
            render: (text) => (
                <a className="inline-flex items-center gap-2 text-sm text-surface-700 hover:text-primary-600 transition-colors" href={`mailto:${text}`}>
                    <Mail className="text-surface-400 text-[13px]" />
                    {text}
                </a>
            )
        },
        {
            title: 'Canal',
            dataIndex: 'channel',
            key: 'channel',
            render: (text) => <StatusTag tone={text === 'moderno' ? 'info' : 'warning'}>{text === 'moderno' ? 'Moderno' : 'Tradicional'}</StatusTag>,
            filters: [
                { text: 'Moderno', value: 'moderno' },
                { text: 'Tradicional', value: 'tradicional' }
            ],
            onFilter: (value, record) => record.channel === value
        },
        // Only roles that may remove auditors get the action column (Análisis Auditor doesn't).
        removeAuditor && {
            title: 'Acciones',
            dataIndex: '_id',
            key: '_id',
            align: 'right',
            width: 96,
            render: (text) => (
                <IconActions>
                    <Popconfirm
                        title="Borrar Auditor"
                        description="¿Estás seguro que deseas eliminar este auditor?"
                        onConfirm={() => removeAuditor(text)}
                        okText="Sí"
                        cancelText="No"
                        okButtonProps={{ danger: true }}>
                        <Tooltip title="Eliminar">
                            <Button type="text" size="small" danger icon={<Trash2 />} aria-label="Eliminar" />
                        </Tooltip>
                    </Popconfirm>
                </IconActions>
            )
        }
    ].filter(Boolean);

    return (
        <div>
            <AuditorsTableActions auditors={auditors} setRows={setRows} exporting={exporting} onExport={onExport} />
            <SectionCard flush>
                <Table
                    columns={AuditorColumns}
                    dataSource={rows}
                    loading={loading}
                    size="middle"
                    scroll={{ x: 'max-content' }}
                    locale={{ emptyText: <EmptyState icon={<UserCheck />} title="Sin auditores" description="No hay auditores que coincidan con la búsqueda" /> }}
                    pagination={{
                        pageSize: 20,
                        showSizeChanger: true,
                        showTotal: (total) => `Total ${total} auditores`
                    }}
                    rowKey="_id"
                />
            </SectionCard>
        </div>
    );
}

export default AuditorsTable;
